<template>
  <q-page>
    <div v-if="$apollo.loading">Loading...</div>
    <q-table v-else title="Accounts" :columns="columns" :data="accounts" :pagination.sync="pagination" flat :filter="filter" binary-state-sort>
      <template v-slot:top>
        <q-space />
        <q-input dense debounce="300" color="primary" v-model="filter">
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template v-slot:body="props">
        <q-tr :props="props">
          <q-td key="verified" :props="props">
            <q-checkbox disabled :value="!!props.row.verifiedAt"></q-checkbox>
          </q-td>
          <q-td key="company" :props="props"><router-link :to="`/admin/accounts/${props.row.id}`">{{props.row.companyName}}</router-link></q-td>
          <q-td key="contactName" :props="props">{{props.row.contactName}}</q-td>
          <q-td key="email" :props="props">{{props.row.email}}</q-td>
          <q-td key="phone" :props="props">{{props.row.contactPhone}}</q-td>
          <q-td key="address" :props="props">{{props.row.shippingAddress}}</q-td>
          <q-td key="created" :props="props">{{fromNow(props.row.createdAt)}}</q-td>
          <q-td key="lastLogin" :props="props">{{fromNow(props.row.lastLogin)}}</q-td>
          <q-td key="actions" :props="props">
            <q-btn dense flat icon="edit" size="sm" :to="`/admin/accounts/${props.row.id}`"></q-btn>
            <q-btn dense flat icon="delete" size="sm" @click="deleteAccount(props.row)"></q-btn>
          </q-td>
        </q-tr>
      </template>
    </q-table>
  </q-page>
</template>

<script>
import moment from 'moment'
import gql from 'graphql-tag'

export default {
  name: 'PageAdminAccounts',
  apollo: {
    accounts: {
      query: gql`
        query {
          accounts {
            id,
            email,
            companyName,
            isAdmin,
            ABNACN,
            contactName,
            contactPhone,
            shippingAddress,
            createdAt,
            verifiedAt
          }
        }
      `,
      fetchPolicy: 'network-only'
    }
  },
  methods: {
    fromNow (t) {
      if (!t) return 'Unknown'
      return moment(t).fromNow()
    },
    deleteAccount (account) {
      this.$q.dialog({
        title: 'Delete Account',
        message: `Are you sure you want to delete ${account.companyName}?`,
        cancel: true
      }).onOk(() => {
        // this.deleteCartItem(item)
        console.log('implement delete!')
      })
    }
  },
  data () {
    return {
      filter: '',
      columns: [
        { name: 'verified', align: 'left', required: true, label: 'Verified', field: row => row.verified, sortable:true },
        { name: 'company', align: 'left', required: true, label: 'Company', field: 'companyName', sortable: true },
        { name: 'contactName', align: 'left', required: true, label: 'Contact', field: 'contactName', sortable: true },
        { name: 'email', align: 'left', required: true, label: 'Email', field: 'email', sortable: true },
        { name: 'phone', align: 'left', required: true, label: 'Phone', field: 'phoneNumber', sortable: true },
        { name: 'address', align: 'left', required: true, label: 'Address', field: 'address', sortable: true },
        { name: 'created', align: 'left', required: true, label: 'Account Created', field: 'lastLogin', sortable: true },
        { name: 'lastLogin', align: 'left', required: true, label: 'Last Login', field: 'lastLogin', sortable: true },
        { name: 'actions', align: 'center', required: true, label: 'Actions', field: '', sortable: false }
      ],
      pagination: {
        rowsPerPage: 100
      }
    }
  }
}
</script>
